import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Mail } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email");
  const [status, setStatus] = useState("loading"); // loading | done | error | no-email

  useEffect(() => {
    if (!email) { setStatus("no-email"); return; }
    (async () => {
      try {
        await api.get(`/newsletter/unsubscribe?email=${encodeURIComponent(email)}`);
        setStatus("done");
      } catch {
        setStatus("error");
      }
    })();
  }, [email]);

  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="unsubscribe-page">
      <SiteHeader />
      <section className="max-w-2xl mx-auto px-6 py-24 text-center">
        {status === "loading" && (
          <>
            <Mail className="h-12 w-12 text-zinc-500 mx-auto mb-4 animate-pulse" />
            <h1 className="font-display text-3xl text-white uppercase tracking-tight mb-2">Processing…</h1>
          </>
        )}
        {status === "no-email" && (
          <>
            <XCircle className="h-12 w-12 text-amber-400 mx-auto mb-4" />
            <h1 className="font-display text-3xl text-white uppercase tracking-tight mb-2">Missing email</h1>
            <p className="text-zinc-400">Use the unsubscribe link from a Better Through Boxing email.</p>
          </>
        )}
        {status === "done" && (
          <>
            <CheckCircle2 className="h-14 w-14 text-emerald-400 mx-auto mb-4" />
            <h1 className="font-display text-3xl text-white uppercase tracking-tight mb-2" data-testid="unsubscribe-success">You're unsubscribed.</h1>
            <p className="text-zinc-400 mb-2"><span className="text-white font-bold">{email}</span> is off the list. No more emails from us.</p>
            <p className="text-zinc-500 text-sm mt-6">Mind sharing why? Just reply to any past email — Coach reads every reply.</p>
            <div className="mt-8"><Link to="/" className="text-[#FF331F] font-bold uppercase tracking-widest text-sm">← Back to home</Link></div>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-red-400 mx-auto mb-4" />
            <h1 className="font-display text-3xl text-white uppercase tracking-tight mb-2">Something went wrong</h1>
            <p className="text-zinc-400">Please email <a href="mailto:theflowstatemethodllc@gmail.com" className="text-[#FF331F] underline">theflowstatemethodllc@gmail.com</a> and we'll remove you manually.</p>
          </>
        )}
      </section>
      <SiteFooter />
    </div>
  );
}
